// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 广告营销服务申请详情 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /promotion-service-apply/info */
export async function promotionServiceApplyInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.promotionServiceApplyInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultPromotionServiceApplyInfoResp>('/promotion-service-apply/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 广告营销服务提交申请 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /promotion-service-apply/submit */
export async function promotionServiceApplySubmitUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.promotionServiceApplySubmitUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/promotion-service-apply/submit', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
